import React from "react";
import { PublicRoute } from "Views/CustomRoutes";
import { LandingPage } from "Views/LandingPage";
import { ApplicationCompletePage } from "./ApplicationCompletePage";
import { ApplicationRequiresReviewPage } from "./ApplicationRequiresReviewPage";
import { ClaimSubmittedPage } from "./ClaimSubmittedPage";
import { FileClaimPage } from "./FileClaimPage";
import { LcpPaths } from "./LcpPaths";
import { LossPayeeAddedPage } from "./LossPayeeAddedPage";
import { LossPayeeAlreadyAddedPage } from "./LossPayeeAlreadyAddedPage";
import { QuoteSavedPage } from "./QuoteSavedPage";

export function getLcpRoutes() {
  return [
    <PublicRoute exact path={LcpPaths.FileClaim} key="fileClaim">
      <FileClaimPage />
    </PublicRoute>,
    <PublicRoute exact path={LcpPaths.ClaimSubmitted} key="claimsSubmitted">
      <ClaimSubmittedPage />
    </PublicRoute>,
    <PublicRoute exact path={LcpPaths.Landing} key="landing">
      <LandingPage />
    </PublicRoute>,
    <PublicRoute
      exact
      path={LcpPaths.ApplicationComplete({
        app: { securityKey: ":securityKey" },
      })}
      key="applicationComplete"
    >
      <ApplicationCompletePage />
    </PublicRoute>,
    <PublicRoute
      exact
      path={LcpPaths.QuoteSaved({ app: { securityKey: ":securityKey" } })}
      key="quoteSaved"
    >
      <QuoteSavedPage />
    </PublicRoute>,
    <PublicRoute exact path={LcpPaths.ApplicationRequiresReview} key="applicationRequiresReview">
      <ApplicationRequiresReviewPage />
    </PublicRoute>,
    <PublicRoute exact path={LcpPaths.LossPayeeAdded} key="lossPayeeAdded">
      <LossPayeeAddedPage />
    </PublicRoute>,
    <PublicRoute exact path={LcpPaths.LossPayeeAlreadyAdded} key="lossPayeeAlreadyAdded">
      <LossPayeeAlreadyAddedPage />
    </PublicRoute>,
  ];
}
